import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLetterASquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="letter-a-square, key"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.14844 16.2275L11.1484 7.77246H12.8535L15.8535 16.2275H14.2715L13.5625 14.042H10.4336L9.73047 16.2275H8.14844ZM11.9512 9.34277L10.8145 12.876H13.1875L12.0508 9.34277H11.9512Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLetterASquare;
